import { forkJoin, Observable, tap } from 'rxjs';
import { inject, provideAppInitializer } from '@angular/core';
import { LocaleService } from '@services/locale.service';
import { CentralServerService } from '../services/central-server.service';
import { EnvironmentService } from '../services/environment.service';
import { MixpanelService } from '../services/mixpanel.service';

export const appInitProvider = provideAppInitializer(() => {
  const centralServerService = inject(CentralServerService);
  const environmentService = inject(EnvironmentService);
  const mixpanelService = inject(MixpanelService);
  const localeService = inject(LocaleService);

  return forkJoin([
    environmentService.init().pipe(
      tap(() => {
        mixpanelService.init();
      }),
    ),
    new Observable((observer) => {
      centralServerService.initUserToken();
      localeService.initLocale();
      observer.next();
      observer.complete();
    }),
  ]);
});
